import { FC } from "react";

import styled from "@emotion/styled";
import { IconArrowUpRight } from "src/ui/assets/icons/IconArrowUpRight";
import Translate from "src/ui/components/Translate/Translate";

import {
  AppPopup,
  AppQueryPopupsController
} from "../AppQueryPopups/AppQueryPopupsBloc";

const Link = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 2px;
  flex-shrink: 0;
  margin: 0;
  padding: 0.5rem 0.5rem 0.5rem 0.75rem;
  border: none;
  border-radius: 120px;
  background: var(--color-cream-darker, #f2efe7);
  cursor: pointer;
  color: var(--color-charcoal, #212121);
  font-size: 0.875rem;
  font-weight: 500;
  line-height: 1.43;
  letter-spacing: -0.28px;
  white-space: nowrap;

  svg {
    flex-shrink: 0;
    width: 1rem;
    height: 1rem;
  }
`;

const MealPlannerLink: FC = () => {
  const openMealPlanning = (): void => {
    AppQueryPopupsController.openPopup(AppPopup.mealPlanning);
  };

  return (
    <Link type="button" onClick={openMealPlanning}>
      <Translate msg="mealInsights.openMealPlanner" />
      <IconArrowUpRight />
    </Link>
  );
};

export default MealPlannerLink;
